import instantInkLogoDark from '../flows/shared/ThankYouStep/instant-ink-logo-dark.svg'
import instantInkLogoLight from '../flows/shared/ThankYouStep/instant-ink-logo.svg'
import { useResolvedThemeMode } from './useResolvedThemeMode'

export const useInstantInkLogo = (): string => {
  const mode = useResolvedThemeMode()
  return mode === 'dark' ? instantInkLogoLight : instantInkLogoDark
}
